module.exports = __webpack_public_path__ + "static/media/create-task-empty-mob.be01652a.png";